  const MoengageEventGenerator = (eventName, attributeValue) => {
    if(process.env.VUE_APP_MOENGAGE_ACTIVE !== "false" && typeof window?.clevertap != undefined ){
      // window.Moengage?.track_event(eventName,attributeValue);
      window.clevertap.event.push(eventName, attributeValue
       );
      // Vue.this.$gtag.event(eventName,attributeValue);
    }
   
   
};

export default MoengageEventGenerator;